import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage       from "./pages/LandingPage";
import LoginPage         from "./pages/LoginPage";
import SignupPage        from "./pages/SignupPage";
import DashboardPage     from "./pages/DashboardPage";
import ResultsPage       from "./pages/ResultsPage";
import ProfilePage       from "./pages/ProfilePage";
import RequisitionsPage  from "./pages/RequisitionsPage";
import PrescriptionsPage from "./pages/PrescriptionsPage";
import RecordsPage       from "./pages/RecordsPage";
// import MessagesPage      from "./pages/MessagesPage";
// import BillingPage       from "./pages/BillingPage";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("access");
  return token ? children : <Navigate to="/login" replace />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/"       element={<LandingPage />} />
        <Route path="/login"  element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />

        {/* Protected */}
        <Route path="/dashboard"     element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/results"       element={<ProtectedRoute><ResultsPage /></ProtectedRoute>} />
        <Route path="/profile"       element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/requisitions"  element={<ProtectedRoute><RequisitionsPage /></ProtectedRoute>} />
        <Route path="/prescriptions" element={<ProtectedRoute><PrescriptionsPage /></ProtectedRoute>} />
        <Route path="/records"       element={<ProtectedRoute><RecordsPage /></ProtectedRoute>} />
        {/* <Route path="/messages"      element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
        <Route path="/billing"       element={<ProtectedRoute><BillingPage /></ProtectedRoute>} /> */}

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}